import { Edit03Icon } from '@langchain/untitled-ui-icons';

import { useState } from 'react';

import { Button, IconButton, Tooltip } from '@/design-system';
import EditIcon from '@/icons/EditIcon.svg?react';

import { RunSchema } from '../types/schema';
import { RunAnnotationsCrudPane } from './RunAnnotationCrudPane/RunAnnotationsCrudPane';

export function RunFeedbackButtons({
  run,
  size,
  onFeedbackGiven,
  condensed,
  enableRedesign,
  className,
  ...props
}: {
  run: RunSchema;
  size?: 'xs' | 'sm';
  disabled?: boolean;
  className?: string;
  onFeedbackGiven?: () => void;
  condensed?: boolean;
  enableRedesign?: boolean;
}) {
  const [isAnnotationsPaneOpen, setIsAnnotationsPaneOpen] = useState(false);

  const handleClickAnnotations = () => {
    setIsAnnotationsPaneOpen(true);
  };

  if (enableRedesign) {
    return (
      <>
        {condensed ? (
          <IconButton
            color="secondary"
            aria-controls={isAnnotationsPaneOpen ? 'basic-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={isAnnotationsPaneOpen ? 'true' : undefined}
            onClick={handleClickAnnotations}
            variant="outlined"
            icon={Edit03Icon}
            label="Annotate Run"
            tooltipProps={{
              side: 'bottom',
            }}
            className={className}
            size={size === 'xs' ? 'sm' : 'md'}
          />
        ) : (
          <Tooltip title="Annotate Run" side="bottom">
            <Button
              color="secondary"
              aria-controls={isAnnotationsPaneOpen ? 'basic-menu' : undefined}
              aria-haspopup="true"
              aria-expanded={isAnnotationsPaneOpen ? 'true' : undefined}
              onClick={handleClickAnnotations}
              variant="outlined"
              leftDecorator={Edit03Icon}
              size={size === 'xs' ? 'sm' : 'md'}
              className={className}
              {...props}
            >
              Annotate
            </Button>
          </Tooltip>
        )}
        <RunAnnotationsCrudPane
          isOpen={isAnnotationsPaneOpen}
          run={run}
          onClose={() => setIsAnnotationsPaneOpen(false)}
          onFeedbackGiven={onFeedbackGiven}
        />
      </>
    );
  }

  return (
    <>
      {condensed ? (
        <IconButton
          size="sm"
          color="secondary"
          aria-controls={isAnnotationsPaneOpen ? 'basic-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={isAnnotationsPaneOpen ? 'true' : undefined}
          onClick={handleClickAnnotations}
          variant="outlined"
          icon={EditIcon}
          label="Annotate Run"
          tooltipProps={{
            side: 'bottom',
          }}
        />
      ) : (
        <Tooltip title="Annotate Run" side="bottom">
          <Button
            aria-controls={isAnnotationsPaneOpen ? 'basic-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={isAnnotationsPaneOpen ? 'true' : undefined}
            onClick={handleClickAnnotations}
            variant="outlined"
            size="sm"
            color="secondary"
            leftDecorator={EditIcon}
            {...props}
          >
            Annotate
          </Button>
        </Tooltip>
      )}
      <RunAnnotationsCrudPane
        isOpen={isAnnotationsPaneOpen}
        run={run}
        onClose={() => setIsAnnotationsPaneOpen(false)}
        onFeedbackGiven={onFeedbackGiven}
      />
    </>
  );
}
